<template>
    <transition name='fade'>
        <div v-if='error' class="error-text">{{error}}</div>
    </transition>
</template>

<script>
export default {
    props : ['errors', 'field_id'],
    data(){
        return{
            error : '',
            field: null
        }
    },
    watch:{
         'errors': {
            handler(){
               this.error = this.errors[this.field_id];
               this.field = this.$parent.$refs['input_field'].children[0];

                if(this.field.classList.contains('typeahead-wrapper')){
                    this.field = this.field.getElementsByTagName('input')[0];
                }

                if (this.error){
                    this.field.classList.add('field-error');
                }
                else{
                    this.field.classList.remove('field-error');
                }
            },
            deep: true
        }
    }
}
</script>

<style lang="scss">
.error-text{
    color:red;
    font-size: 0.8rem;
    margin-top: 5px;
}

.field-error{
    border-width: 2px;
    border-color: rgba(255, 0, 0, 0.4) !important;
}
</style>